"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Session = void 0;
const class_transformer_1 = require("class-transformer");
const account_1 = require("../../account");
const common_1 = require("../../common");
class Session extends common_1.BaseClass {
    static fromStoredSession(storedSession) {
        let result;
        try {
            const { token, ttl } = storedSession;
            const expireAt = new Date(storedSession.expireAt);
            result = new Session({
                token,
                ttl,
                expireAt,
            });
        }
        catch (err) {
            result = null;
        }
        return result;
    }
    refresh() {
        const now = new Date();
        this.expireAt = new Date(now.getTime() + this.ttl * 1000);
    }
    verify() {
        return this.expireAt.getTime() + Session.TTL_MARGIN > Date.now();
    }
    toStoredSession() {
        return {
            token: this.token,
            ttl: this.ttl,
            expireAt: this.expireAt,
        };
    }
}
Session.TTL_MARGIN = 3000;
__decorate([
    (0, class_transformer_1.Type)(() => account_1.Account),
    __metadata("design:type", account_1.Account)
], Session.prototype, "account", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Session.prototype, "expireAt", void 0);
exports.Session = Session;
